import { environment } from "../config";
import { iUser } from "../interfaces/Auth/iUser";
import { Icons } from "../layout/Drawer/Sidebar/Icons";
const { REACT_APP_ADMIN_REPORTS } = environment;

export interface iSidebarItem {
  text: string;
  path: string;
  icon: () => JSX.Element;
}

//Lista de items no accesibles para todos los usuarios
const privateItems: iSidebarItem[] = [
  {
    text: "SandBox",
    path: "sandbox",
    icon: Icons.Biotech,
  },
];

const allowedAdminRoles = ["Admin de Dominio", "Admin de Organización"];

//Esta función decide si el sidebar muestra el "Sandbox" y el "Admin" o no
export const getSidebarItems = (user: iUser | null) => {
  const baseItems: iSidebarItem[] = [
    { text: "Inicio", path: "menu", icon: Icons.Home },

    // Renderizamos solo las categorías que tiene el usuario
    ...(user?.categories.map((cat) => ({
      text: cat.label,
      path: cat.route,
      icon: cat.icon,
    })) || []),

    {
      text: "Mis Trabajos",
      path: "myprojects",
      icon: Icons.BookMark,
    },
    {
      text: "Mis reportes",
      path: "reportes",
      icon: Icons.LeaderBoard,
    },
    ...(user?.roles?.some((role) => allowedAdminRoles.includes(role.rol))
      ? [
          {
            text: "Admin",
            path: "admin",
            icon: Icons.Admin,
          },
        ]
      : []),
  ];

  const filteredItems =
    user?.email?.endsWith("@tuclase.cl") && REACT_APP_ADMIN_REPORTS
      ? privateItems
      : [];
  return [...baseItems, ...filteredItems];
};
